// Copyright (c) 2016 Deere & Company

import './tooltip.scss';
import React, {PropTypes} from 'react';

const ToolTip = props =>
    <div className='tooltip'>
        <div className='tooltip-body'>
            {props.children}
        </div>
    </div>;

ToolTip.displayName = 'Tooltip';
ToolTip.propTypes = {
    children: PropTypes.node
};

export default ToolTip;



// WEBPACK FOOTER //
// ./src/shared/components/popover/tooltip.js